
export default {
	props: {
		searchWords: {
			type: String,
			requried: true
		},
		sort: {
			required: true
		},
		order: {
			required: true
		},
		switchText: {
			type: Boolean,
			required: true
		},
		gameConfig: {
			type: Array,
			required: true
		},
		total: {
			type: Number,
			default: 0
		},
        isGeneralGoods: {
            type: Boolean,
            default: false
        }
	},
	data() {
		return {
            innerValue: ''
        }
	},
	computed: {
		sortOptions() {
			const result = []
            if (!this.isGeneralGoods) {
                result.push({
                    name: '发布时间',
                    sort: 'onStandTime'
                })
            }
			this.gameConfig
				.filter(item => item.fieldType === 'SECTION')
				.forEach(item => {
					result.push({
						name: `${item.propertyName}`,
						sort: item.mappingField
					})
				})
			return result
		}
	},
    watch: {
        searchWords: {
            handler(newVal) {
                this.innerValue = newVal
            },
            immediate: true
        }
    },
	methods: {
        onClear() {
            this.innerValue = ''
            this.onSearch()
        },
		onSearch() {
			this.$emit('update:searchWords', this.innerValue)
			this.$emit('search')
		},
		onClickSort(item) {
			// 默认 DESC
			if (this.sort === item.sort) {
				this.$emit('update:order', this.order === 'DESC' ? 'ASC' : 'DESC')
			} else {
				this.$emit('update:sort', item.sort)
				this.$emit('update:sortName', item.name)
                // 所有价格字段首次点击为升序（从低到高），其他字段为降序（从高到低）
                const order = item.sort.toLowerCase().includes('price') ? 'ASC' : 'DESC'
				this.$emit('update:order', order)
			}
			this.$emit('search')
		},
		// 切换显示文字/图片
		switchTextImg() {
			window.localStorage.setItem('switchText', !this.switchText)
			this.$emit('update:switchText', !this.switchText)
		}
	}
}
